'use strict';

var ROMSummaryCabinFilterFactory = function ROMSummaryCabinFilterFactory(DataFilter) {
  function ROMSummaryCabinFilter() {
    DataFilter.call(this, 'rom-summary-mode', 'cabin', 0);
  }
  ROMSummaryCabinFilter.prototype = Object.create(DataFilter.prototype);
  ROMSummaryCabinFilter.prototype.groupBy = 'cabin';
  return ROMSummaryCabinFilter;
};
ROMSummaryCabinFilterFactory.$inject = ['DataFilterFactory'];
module.exports = ROMSummaryCabinFilterFactory;